/** The websocket bundle owns compile state. Action bundles only consult its window bridge. */
import { encounterField } from './array-types';

/** Painted encounter state is the action snapshot. A required revision gap keeps the
 * ordinary fetch/compile path; background resyncs do not force another cold compile. */
export function heldEncounterForAction(id: string, owner: Window = window): Record<string, unknown> | null {
    const encounter = (owner as Window & { FateTide?: { encounterCache?: { get(id: string): unknown } } })
        .FateTide?.encounterCache?.get(id.toUpperCase());
    return encounter && typeof encounter === 'object' && String(encounterField(encounter, 'encounter_id') ?? '').toUpperCase() === id.toUpperCase()
        && typeof owner.ftRequireEntityBase === 'function' && owner.ftRequireEntityBase(id) !== false
        ? encounter as Record<string, unknown> : null;
}

/** Explicit actions always warn; announce=false limits background repeats to one per saved revision. */
export function entityCompileReady(ids: readonly string[], announce = true): boolean {
    return ids.every(id => window.ftRequireEntityBase?.(id, announce) !== false);
}

/** Saved revisions and compiled surfaces only. Perception sweeps hydrate their
 * own join inputs; they do not depend on movement, cast or turn preloads. */
export async function awaitEntityBaseReady(ids: readonly string[], announce = true): Promise<boolean> {
    if (await window.ftAwaitEntityBase?.(ids) === false) return false;
    return entityCompileReady(ids, announce);
}

/** Join only a never-painted surface or a required revision gap. The websocket bridge
 * leaves ordinary recompiles and resyncs of painted state in the background. */
export async function awaitEntityCompileReady(ids: readonly string[], actorId?: string): Promise<boolean> {
    if (!await awaitEntityBaseReady(ids)) return false;
    return await (window as Window & { ftAwaitActionInputs?: (ids: readonly string[], actorId?: string) => Promise<boolean> }).ftAwaitActionInputs?.(ids, actorId) !== false;
}

/** Actions which hydrate their own inputs keep the actor-aware calling signature
 * without joining the encounter's unrelated adoption preloads. */
export async function awaitEntityActionReady(ids: readonly string[], actorId?: string, inputs: readonly string[] = []): Promise<boolean> {
    if (!await awaitEntityBaseReady(ids)) return false;
    if (!inputs.length) return true;
    return await (window as Window & { ftAwaitActionInputWarmups?:
        (ids: readonly string[], actorId: string | undefined, inputs: readonly string[]) => Promise<boolean>
    }).ftAwaitActionInputWarmups?.(ids, actorId, inputs) !== false;
}
